import levels from "#traditional-word-levels" with { type: "json" };

/** The named accessor lets native Metro defer the other script's JSON initialization. */
export function getTraditionalWordLevels() {
  return levels;
}
